export const CONTACTS_SYNC_INTERVAL = 1000 * 60;
